
import { defineComponent, ref, reactive } from "vue";
import { vLoading, ElPagination } from "element-plus";
import ArticleListItem from "@/components/ArticleListItem";
import { Media } from "@/components/Index";
import { getMedias, getArticles, getAlbums } from "@/services";
import { AlbumModel, ArticleModel, MediaModel } from "@/typings";
import { AlbumItem } from "@/components/EntityListItem";
import { CommentList } from "@/components/Comment";
import { useUserInfo } from "@/store";

export default defineComponent({
    components: {
        ElPagination,
        ArticleListItem,
        Media,
        AlbumItem,
        CommentList,
    },
    directives: {
        vLoading,
    },
    setup() {
        const albumLoading = ref(true);
        const albums = ref<AlbumModel[]>([]);
        const userInfo = useUserInfo();

        getAlbums({
            page: 0,
            filter: {
                rating_anon: 1,
            },
            sort: "year",
        }).then((json) => {
            albumLoading.value = false;
            albums.value = json.data.albums;
        });

        const medias = ref<MediaModel[]>([]);
        const mediaLoading = ref(true);
        getMedias().then((res) => {
            medias.value = res.data.medias;
            mediaLoading.value = false;
        });

        const articleLoading = ref(false);
        const articles = ref<ArticleModel[]>([]);

        const pagination = reactive({
            pageNow: 1,
            total: 0,
        });
        const runGetArticle = () => {
            getArticles(pagination.pageNow).then((res) => {
                articles.value = res.data.articles;
                pagination.total = res.data.pages.total;
                articleLoading.value = false;
            });
        };

        runGetArticle();
        const handlePageChange = (page: number) => {
            pagination.pageNow = page;
            runGetArticle();
        };

        return {
            albums,
            userInfo,
            albumLoading,
            medias,
            mediaLoading,
            articleLoading,
            articles,
            pagination,
            handlePageChange,
        };
    },
});
